import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const TickThin = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M28 5C28 4.45 27.55 4 27 4C26.675 4 26.375 4.162 26.2 4.4L10.987 25.313C10.987 25.313 5.799 18.388 5.787 18.388C5.599 18.15 5.312 18.001 5 18.001C4.45 18.001 4 18.451 4 19.001C4 19.226 4.075 19.426 4.2 19.588L10.212 27.6C10.4 27.838 10.687 28 11.012 28C11.337 28 11.637 27.837 11.812 27.587L27.824 5.575C27.924 5.413 27.999 5.213 27.999 5H28Z" />
	</svg>
);

export default TickThin;
